import dayjs from 'dayjs';
import {
	addDoc,
	arrayRemove,
	arrayUnion,
	collection,
	deleteDoc,
	getDoc,
	doc,
	updateDoc,
} from 'firebase/firestore';
import firebase from 'firebase/app';
import React, { useMemo, useReducer } from 'react';
import {
	useFirestore,
	useFirestoreCollectionData,
	useFirestoreDocData,
} from 'reactfire';
import Swal from 'sweetalert2';

import OrdersContext from './OrdersContext';
import OrdersReducer from './OrdersReducer';

export default function OrdersState({ children }) {
	const initialState = {
		orders: '',
		openNewOrderDialog: false,
		newOrder: {
			name: '',
			description: '',
			dateOfDelivery: null,
			placeOfDelivery: '',
			items: [
				{
					id: 0,
					label: 'Elote',
					category: 'whole',
					value: 0,
					name: 'cornPie',
					checked: false,
				},

				{
					id: 1,
					label: 'Queso',
					category: 'whole',
					value: 0,
					name: 'cheesePie',
					checked: false,
				},
				{
					id: 2,
					label: 'Elote',
					category: 'slice',
					value: 0,
					name: 'cornSlice',
					checked: false,
				},
				{
					id: 3,
					label: 'Queso',
					category: 'slice',
					value: 0,
					name: 'cheeseSlice',
					checked: false,
				},
			],
			createdAt: '',
			status: 'pending',
		},
		isLoading: false,
		toastAlert: { severity: 'success', open: false, message: '' },
		currentOrderId: '',
		filterOption: '',
		filterOrderNav: 'all',
	};
	const [state, dispatch] = useReducer(OrdersReducer, initialState);
	const {
		orders,
		openNewOrderDialog,
		newOrder,
		isLoading,
		toastAlert,
		currentOrderId,
		filterOption,
		filterOrderNav,
	} = state;

	const ordersRef = collection(useFirestore(), 'pedidos');
	const itemsRef = collection(useFirestore(), 'items');
	const deletedOrdersRef = collection(useFirestore(), 'deletedOrders');

	const { data } = useFirestoreCollectionData(ordersRef, {
		idField: 'id',
	});
	useMemo(() => {
		dispatch({
			type: 'GET_ORDERS',
			payload: data,
		});
	}, [data]);

	const toogleNewOrderDialog = (origin) => {
		if (origin) {
			Swal.fire({
				width: 400,
				title: 'Deseas salir?',
				text: 'Los cambios no se guardarán',
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#d33',
				cancelButtonColor: '#3085d6',
				confirmButtonText: 'Salir',
				cancelButtonText: 'Continuar',
				customClass: {
					container: 'my-swal',
				},
			}).then((result) => {
				if (result.isConfirmed) {
					dispatch({
						type: 'TOOGLE_NEW_ORDER_DIALOG',
						payload: !openNewOrderDialog,
					});
				}
			});
		} else {
			dispatch({
				type: 'TOOGLE_NEW_ORDER_DIALOG',
				payload: !openNewOrderDialog,
			});
		}
	};

	const toogleIsLoading = (value) => {
		dispatch({
			type: 'TOOGLE_IS_LOADING',
			payload: value,
		});
	};

	const toogleToastAlert = (severity, open, message) => {
		dispatch({
			type: 'TOOGLE_TOAST_ALERT',
			payload: { severity, open, message },
		});
	};

	const addNewOrder = async (newOrderData) => {
		const currentUser = JSON.parse(localStorage.getItem('user'));

		const newOrderDataTest = {
			...newOrderData,
			createdAt: dayjs().format(),
			createdBy: currentUser.email,
			createdByUserId: currentUser.uid,
		};
		console.log(newOrderDataTest);
		// eslint-disable-next-line no-param-reassign
		try {
			await addDoc(ordersRef, newOrderDataTest);
			toogleToastAlert('success', true, 'Pedido agregado!');
		} catch (e) {
			toogleToastAlert('error', true, 'No se pudo agregar!');
		}
		toogleIsLoading(false);

		toogleNewOrderDialog();
	};

	const deleteSpecificOrder = async (id) => {
		const currentUser = JSON.parse(localStorage.getItem('user'));
		try {
			const orderDoc = await getDoc(doc(ordersRef, id));

			if (orderDoc.exists) {
				const deletedOrder = {
					...orderDoc.data(),
					deletedAt: dayjs().format(),
					deletedBy: currentUser.email,
					status: 'cancel',
				};
				await addDoc(deletedOrdersRef, deletedOrder);
			}

			await deleteDoc(doc(ordersRef, id));
			toogleToastAlert('success', true, 'Pedido eliminado correctamente!');
		} catch (error) {
			toogleToastAlert('error', true, 'Error al eliminar pedido!');
			console.error(error);
		}
	};

	const setCurrentOrderId = (orderId) => {
		dispatch({
			type: 'SET_CURRENT_ORDER_ID',
			payload: orderId,
		});
	};

	const setOrderStatus = async (id, newStatus) => {
		try {
			await updateDoc(doc(ordersRef, id), { status: newStatus });
		} catch (e) {
			console.error(e);
		}
	};
	const onChangeCheckedItem = async (id, currentStatus, item) => {
		try {
			await updateDoc(doc(ordersRef, id), {
				items: arrayRemove({ ...item }),
			}).then(async () => {
				await updateDoc(doc(ordersRef, id), {
					items: arrayUnion({ ...item, checked: currentStatus }),
				});
			});
		} catch (e) {
			console.error(e);
		}
	};

	const editOrder = async (id, order, navigate) => {
		const currentUser = JSON.parse(localStorage.getItem('user'));

		try {
			await updateDoc(doc(ordersRef, id), {
				...order,
				updatedBy: currentUser.email,
			}).then((r) => {
				toogleIsLoading(false);
				navigate(-1);
				toogleToastAlert('success', true, 'Pedido modificado correctamente!');
			});
		} catch (e) {
			console.error(e);
		}
	};

	const onChangeFilterOption = (option) => {
		if (option.value === 'clean') {
			dispatch({
				type: 'SET_FILTER_OPTION',
				payload: '',
			});
		} else {
			dispatch({
				type: 'SET_FILTER_OPTION',
				payload: option,
			});
		}
	};
	const onChangeFilterOrderNav = (value) => {
		dispatch({
			type: 'SET_FILTER_ORDER_NAV',
			payload: value,
		});
	};

	return (
		<OrdersContext.Provider
			value={{
				orders,
				openNewOrderDialog,
				isLoading,
				toastAlert,
				ordersRef,
				itemsRef,
				currentOrderId,
				filterOption,
				filterOrderNav,
				toogleNewOrderDialog,
				newOrder,
				addNewOrder,
				toogleIsLoading,
				toogleToastAlert,
				deleteSpecificOrder,
				setCurrentOrderId,
				setOrderStatus,
				onChangeCheckedItem,
				editOrder,
				onChangeFilterOption,
				onChangeFilterOrderNav,
				// getOrders,
			}}
		>
			{children}
		</OrdersContext.Provider>
	);
}
